// import React from 'react';
// import { ReactComponent as SpinnerIcon } from '../icons/spinner.svg';
// import ErrorMessage from './ErrorMessage';

// export default function Loader(props) {
//     return (
//         <div className="container p-4 flex flex items-center justify-center">
//             {props.isError ?
//                 <ErrorMessage />
//                 :
//                 <SpinnerIcon className="animate-spin -ml-1 mr-3 h-12 w-12 text-contrast-1" />
//             }
//         </div>
//     );
// }

import React from 'react';
import { getLabel } from '../data/labels';
import ErrorMessage from './ErrorMessage';

export default function Loader(props) {
    return (
        <div className={"xs_loaderContainer container p-4  flex items-center justify-center" + (props.centered ? ' absolute h-full' : '')}>
            {props.error ?
                <ErrorMessage showBackButton={props.showBackButton} />
                :
                <div className="xs_loader px-10 py-4 flex flex-col items-center justify-center bg-cs7 rounded-md shadow-sm shadow-shadow">
                    <div className="animate-spin h-10 w-10 rounded-full border border-4 border-cs16 border-t-cs8"></div>
                    <span className="pt-2 text-fs2 text-cs8">{getLabel('general.loading')}</span>
                </div>
            }
        </div>
    );

}

